/**
 * Runtime assertion for unreachable code reached.
 *
 * @param arg - the value that should be unreachable
 * @param msg - the error to show if it is reached
 */
export const never = (arg: never, msg?: string): never => {
  throw new Error(`${JSON.stringify(arg)}${msg ? ` | ${msg}` : ``}`);
};
